<template>
  <div class="style-message mt-5">
    {{ message }}
  </div>
</template>

<script>
export default {
  name: "ItemNotFound",
  props: { message: String },
  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
.style-message {
  color: #979797;
  font-weight: $font-bold;
}
</style>
